import { Component, Vue, } from 'vue-property-decorator';
import ActionIcon from '@/components/action-icon/ActionIcon.vue';

@Component<ActionEditIcon>({
  components: {
    'action-icon': ActionIcon,
  }
})
export default class ActionEditIcon extends Vue { }
